import { Icon } from '@bannerflow/ui';
import { CreativeSize } from '@domain/creativeset';
import { IBrandSizeGroup } from '@domain/brand';

export interface ISelectableSize extends CreativeSize {
    id: string;
    thumbSize?: { width: number; height: number; ratio: number };
    selected?: boolean;
    amount: number;
    compatibility?: SizeCompatibility[];
    thumbnail?: Icon;
}

export interface ISizeCollection extends IBrandSizeGroup {}

export type SizeCategoryType = 'custom' | 'brand' | 'social' | 'group';

export interface ISizeList {
    type: SizeCategoryType;
    label: string;
    sizes: ISelectableSize[];
    stickyHeight?: number;
    collapsed?: boolean;
}

export enum SizeCompatibility {
    Facebook = 'facebook',
    Instagram = 'instagram',
    Messenger = 'messenger',
    YouTube = 'youtube',
    Tiktok = 'tiktok',
    Snapchat = 'snapchat',
    Linkedin = 'linkedin',
    Twitter = 'twitter',
    Pinterest = 'pinterest'
}
